import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { ADMIN_API_BASE_URL } from '../../config';

/**
 * Admin API service for making HTTP requests to the admin API
 * Extends ApiService with admin-specific base URL
 */
@Injectable({
  providedIn: 'root'
})
export class AdminApiService extends ApiService {
  protected override http = inject(HttpClient);
  public override baseUrl = inject(ADMIN_API_BASE_URL);
}
